// map
var markers_map = [];
var map, activeIndex, locList;
var markers = [];
var currentInfoWindow;
var markerCluster;
var marker;
var markerPosition;
var content, infowindow;
var iconBase = '../images/map-icons/';
var icons = {
    about: {
        icon: iconBase + 'about.svg'
    },
    entertainment: {
        icon: iconBase + 'entertainment.png'
    },
    events: {
        icon: iconBase + 'events.svg'
    },
    explore: {
        icon: iconBase + 'explore.svg'
    },
    map: {
        icon: iconBase + 'map.svg'
    },
    places: {
        icon: iconBase + 'places.svg'
    }
};

function openMap(i) {
    google.maps.event.trigger(markers[i], 'click');
}

function cardMarkers() {
    locList = $(".map-places .card-item");
    locList.each(function () {
        markers_map.push([$(this).find(".card-name").text(), $(this).attr("data-lat"), $(this).attr("data-lng"), $(this).attr("data-icon"), $(this).attr("data-img"), $(this).find(".card-address").text(), $(this).find(".card-name a").attr("href")]);
    });
}

if ($(".map-places").length) {
    cardMarkers();
}

if ($(".project-address").length) {
    locList = $(".map-item");
    locList.each(function () {
        markers_map.push([$(this).find(".title a").text(), $(this).attr("data-lat"), $(this).attr("data-lng"), $(this).attr("data-icon"), $(this).attr("data-img"), $(this).find(".address p").text(), $(this).find(".title a").attr("href")]);
    });
}

function initMap_prev() {
    initMap(markers_map);
    // initialize()
    // activeLocation();
}

function initMap(markers_map) {
    var mapStyle = [{
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [{"color": "#e9e9e9"}, {"lightness": 17}]
    }, {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [{"color": "#f5f5f5"}, {"lightness": 20}]
    }, {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [{"color": "#ffffff"}, {"lightness": 17}]
    }, {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [{"color": "#ffffff"}, {"lightness": 29}, {"weight": 0.2}]
    }, {
        "featureType": "road.arterial",
        "elementType": "geometry",
        "stylers": [{"color": "#ffffff"}, {"lightness": 18}]
    }, {
        "featureType": "road.local",
        "elementType": "geometry",
        "stylers": [{"color": "#ffffff"}, {"lightness": 16}]
    }, {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [{"color": "#f5f5f5"}, {"lightness": 21}]
    }, {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [{"color": "#dedede"}, {"lightness": 21}]
    }, {
        "elementType": "labels.text.stroke",
        "stylers": [{"visibility": "on"}, {"color": "#ffffff"}, {"lightness": 16}]
    }, {
        "elementType": "labels.text.fill",
        "stylers": [{"saturation": 36}, {"color": "#333333"}, {"lightness": 40}]
    }, {"elementType": "labels.icon", "stylers": [{"visibility": "off"}]}, {
        "featureType": "transit",
        "elementType": "geometry",
        "stylers": [{"color": "#f2f2f2"}, {"lightness": 19}]
    }, {
        "featureType": "administrative",
        "elementType": "geometry.fill",
        "stylers": [{"color": "#fefefe"}, {"lightness": 20}]
    }, {
        "featureType": "administrative",
        "elementType": "geometry.stroke",
        "stylers": [{"color": "#fefefe"}, {"lightness": 17}, {"weight": 1.2}]
    }];
    var mapOptions = {
        zoom: 16,
        disableDefaultUI: true,
        clickableLabels: false,
        styles: mapStyle
        // scrollwheel: false,
        // gestureHandling: 'cooperative'
    };

    var mapElement = document.getElementById('map-item');
    map = new google.maps.Map(mapElement, mapOptions);



    if (markers_map.length !== 0) {
        var n = ["m1", "m2", "m3", "m4", "m5"].map(function (e) {
            return {url: "/images/clusters/".concat(e, ".png"), width: 30, height: 30, textColor: "black", textSize: 11}
        });
        markerCluster = new MarkerClusterer(map, [], {
            imagePath: "/images/clusters/m",
            maxZoom: 16,
            minimumClusterSize: 2,
            gridSize: 30,
            styles: n
        });

        // if ($("#map-item").data("no-point") != true) {
        addMarkers(markers_map, map);
        /*} else {
        var markerPosition = new google.maps.LatLng(markers_map[0][1], markers_map[0][2]);
        map.setCenter(markerPosition);
    }*/
    } else {
        let center = {lat: 51.491484, lng: 31.293627};
        // map.setOptions({ maxZoom: 12 });

        map.setCenter(center);
        map.setZoom(12);

       /* setTimeout(function () {
            map.setOptions({ maxZoom: 21 });
        }, 500)*/
    }



}


function addMarkers(markers_map, map, zoom = 16) {
    var markersBounds = new google.maps.LatLngBounds();
    for (var i = 0; i < markers_map.length; i++) {
        markerPosition = new google.maps.LatLng(markers_map[i][1], markers_map[i][2]);

        // Создаём маркер
        marker = new google.maps.Marker({
            position: markerPosition,
            map: map,
            id: i,
            // icon: icons[markers_map[i][3]].icon,
            icon: markers_map[i][3],
            draggable: false,
            title: markers_map[i][0],
            labelClass: "labels",
            link: markers_map[i][3],
        });
        // Добавляем координаты маркера в область
        markersBounds.extend(markerPosition);

        // marker.id = i;

        markers.push(marker);
        markerCluster.addMarker(marker);


        content = "<div class='map-window flex wrap aCenter'><div class='window-title'><p><a href='" + markers_map[i][6] + "'>" + markers_map[i][0] + "</a>" + markers_map[i][5] + "</p></div><div class='window-img'><img src='" + markers_map[i][4] + "' alt=''></div></div>";


        infowindow = new google.maps.InfoWindow();
        google.maps.event.addListener(marker, 'click', (function (marker, content, infowindow) {
            return function () {
                if (currentInfoWindow != null) {
                    currentInfoWindow.close();
                }
                infowindow.setContent(content);
                infowindow.open(map, marker);
                currentInfoWindow = infowindow;
            };
        })(marker, content, infowindow));

        google.maps.event.addListener(map, 'click', function (event) {
            if (currentInfoWindow) {
                currentInfoWindow.close();
            }
        });


        marker.addListener('click', function () {
            map.setZoom(16);
            map.panTo($(this)[0].getPosition());
            if(!$(".project-address").length) {
                $(".place-info").addClass("open");
                load_page($(".map-places .card-item").eq(this.id).find(".card-name a").attr("href"));
            }
        });


    }
    // Центрируем и масштабируем карту

        if (markers_map.length > 1) {
        map.setOptions({ maxZoom: 16 });
        map.fitBounds(markersBounds);
        setTimeout(function () {
            map.setOptions({ maxZoom: 21 });
        }, 500)

    } else {
        map.setOptions({ maxZoom: 16 });
        map.setCenter(markersBounds.getCenter());
        if (infowindow) {
            infowindow.setContent(content);
            infowindow.open(map, marker);
        }
        setTimeout(function () {
            map.setOptions({ maxZoom: 21 });
        }, 500);
    }

    // map.setZoom(zoom);
}


// Sets the map on all markers in the array.
function setMapOnAll(map) {
    for (var i = 0; i < markers.length; i++) {
        markers[i].setMap(map);
    }
}

function clearMarkers() {
    setMapOnAll(null);
}

// Shows any markers currently in the array.
function showMarkers() {
    setMapOnAll(map);
}

// Deletes all markers in the array by removing references to them.
function deleteMarkers() {
    clearMarkers();
    markers = [];
    markers_map = [];
    markerCluster.clearMarkers();
}

function returnMarkers() {
    cardMarkers();
    addMarkers(markers_map, map);
}


// map


$(document).ready(function () {
    if ($("#map-item").length > 0) {
        $("#map-item").after('<script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyA6sLxnYQ-FWAeI8mmJpv2LNinG0u-H5aw&libraries=places&callback=initMap_prev"></script>');
        // initMap_prev();
    }

});